<div class="approval-details-container">
    <!-- <div class="header" fxLayout="row" fxLayoutAlign="start">
        <div class="img-icon"> <nb-icon class="prev" (click)="goBack()" icon="arrow-back-outline"></nb-icon></div>
        <div class="header-title">
            <span>{{headerTitle}}</span>
        </div>
    </div> -->
    <div class="approval-details-body"
        [ngStyle]="{'max-height': parentData?.tickets && parentData?.tickets.length > 0 ? '400px' : '200px'}">

    <!-- template for Attendance request -->


    <ng-container *ngIf="parentData?.appName === 'Attendance Request'">
        <ng-container *ngIf="parentData?.tickets && parentData?.tickets.length > 0">
            <ng-container *ngFor="let item of parentData?.tickets; let i=index">

                <div fxLayout="column" class="request-container" *ngFor="let request of item?.requests;let j=index" [ngClass]="{'first-card': i === 0}">
                    <div class="request-details">
                        <div class="name">{{item?.employeeName}}’s Attendance request is waiting for your approval</div>

                        <div class="date">
                            {{request?.date}}
                        </div>
                        <div style="width: 100%;" class="remark">
                            <div style="width:100%">
                                <textarea class="remark-textarea" [(ngModel)]="request.remark" nbInput
                                    placeholder="Please enter your remarks" (ngModelChange)="request.showRemarkError = false"></textarea>
                                    <div class="error" *ngIf="request.showRemarkError">Please enter your remarks</div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!(request.isApproved || request.isDeclined)" class="action-btns" fxLayout="row"
                        fxLayoutAlign="space-between center" fxFlex="100">

                        <div fxFlex="50" style="margin-right: 5px;">
                            <button class="decline" (click)="declineRequest(j,item,request)" nbButton size="small">
                                {{ 'Decline' }}
                            </button>
                        </div>
                        <div fxFlex="50" style="margin-left: 5px;">
                            <button class="approve" (click)="approveRequest(j,item,request)" nbButton size="small">
                                {{ 'Approve' }}
                            </button>
                        </div>

                    </div>
                    <div *ngIf="(request.isApproved || request.isDeclined)" class="action-btns" fxLayout="row"
                        fxLayoutAlign="space-between center" fxFlex="100">

                        <div *ngIf="request.isDeclined" fxFlex="100" style="margin-right: 5px;">
                            <button class="decline"  nbButton size="small" [disabled]="true">
                                {{ 'Declined' }}
                            </button>
                        </div>
                        <div *ngIf="request.isApproved" fxFlex="100" style="margin-left: 5px;">
                            <button class="approve" nbButton size="small" [disabled]="true">
                                {{ 'Approved' }}
                            </button>
                        </div>

                    </div>

                </div>  

            </ng-container>
        </ng-container>

        <!-- Check if there are no tickets -->
        <div *ngIf="!parentData?.tickets || parentData?.tickets.length === 0" class="no-data-message">
            <div class="empty-data" fxFlex="100" fxLayout="column" fxLayoutAlign="center center">
                <div>
                    <img height="80" [src]="EmptyState" alt="Empty">
                </div>
                <span>No Pending Requests found.</span>
            </div>
        </div>
    </ng-container>

    <!-- template for leave request -->

    <ng-container *ngIf="parentData?.appName === 'Leave Request'">
        <ng-container *ngIf="parentData?.tickets && parentData?.tickets.length > 0">
            <ng-container *ngFor="let item of parentData?.tickets; let i=index">

                <div class="request-container" *ngFor="let request of item?.requests;let j=index" fxLayout="column">
                    <div class="request-details">
                        <div class="name">{{item?.employeeName}}’s Leave request is waiting for your approval</div>

                        <div class="date">
                            {{request.leaveType}}
                        </div>
                        <div class="date">
                            {{request?.leaveFrom}} to {{request?.leaveTo}}
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start start" class="vendor">
                                        <div>No of days:&nbsp;</div>
                                        <div>{{request?.leaveQuantityInDays}}</div>
                                    </div>

                        <div class="date">
                            {{request?.date}}
                        </div>
                        <div style="width: 100%;" class="remark">
                            <div style="width:100%">
                                <textarea class="remark-textarea" [(ngModel)]="request.remark" nbInput
                                    placeholder="Please enter your remarks" (ngModelChange)="request.showRemarkError = false"></textarea>
                                    <div class="error" *ngIf="request.showRemarkError">Please enter your remarks</div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!request['isApproved'] && !request['isDeclined']" class="action-btns" fxLayout="row"
                        fxLayoutAlign="space-between center" fxFlex="100">

                        <div fxFlex="50" style="margin-right: 5px;">
                            <button class="decline" (click)="declineRequest(j,parentData,request,item)" nbButton size="small">
                                {{ 'Decline' }}
                            </button>
                        </div>
                        <div fxFlex="50" style="margin-left: 5px;">
                            <button class="approve" (click)="approveRequest(j,parentData,request,item)" nbButton size="small">
                                {{ 'Approve' }}
                            </button>
                        </div>

                    </div>

                    <div *ngIf="(request.isApproved || request.isDeclined)" class="action-btns" fxLayout="row"
                        fxLayoutAlign="space-between center" fxFlex="100">

                        <div *ngIf="request.isDeclined" fxFlex="100" style="margin-right: 5px;">
                            <button class="decline"  nbButton size="small" [disabled]="true">
                                {{ 'Declined' }}
                            </button>
                        </div>
                        <div *ngIf="request.isApproved" fxFlex="100" style="margin-left: 5px;">
                            <button class="approve" nbButton size="small" [disabled]="true">
                                {{ 'Approved' }}
                            </button>
                        </div>

                    </div>

                </div>

            </ng-container>
        </ng-container>

        <!-- Check if there are no tickets -->
        <div *ngIf="!parentData?.tickets || parentData?.tickets.length === 0" class="no-data-message">
            No Pending Requests found.
        </div>
    </ng-container>

    <ng-container *ngIf="parentData?.appName === 'Accommodation Request'">
        <ng-container *ngIf="parentData?.tickets && parentData?.tickets.length > 0">
            <ng-container>

                <div class="request-container" *ngFor="let request of parentData?.tickets; let i=index" fxLayout="column">
                    <div class="request-details">
                        <div class="name">{{request?.requestorFullName}}’s Accommodation Request is waiting for your approval</div>
                        <div class="name">Request ID : <span class="date">{{request?.requestID}}</span></div>
                        <div class="date">
                            {{request.purpose}}
                        </div>
                        <div class="date">
                            {{request?.fromDate}} to {{request?.toDate}}
                        </div>
                        <!-- <div fxLayout="row" fxLayoutAlign="start start" class="vendor">
                                        <div>No of days:&nbsp;</div>
                                        <div>{{request?.leaveQuantityInDays}}</div>
                                    </div>

                        <div class="date">
                            {{request?.date}}
                        </div> -->
                        <div style="width: 100%;" class="remark">
                            <div style="width:100%">
                                <textarea class="remark-textarea" [(ngModel)]="request.remark" nbInput
                                    placeholder="Please enter your remarks" (ngModelChange)="request.showRemarkError = false"></textarea>
                                    <div class="error" *ngIf="request.showRemarkError">Please enter your remarks</div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!request['isApproved'] && !request['isDeclined']" class="action-btns" fxLayout="row"
                        fxLayoutAlign="space-between center" fxFlex="100">

                        <div fxFlex="50" style="margin-right: 5px;">
                            <button class="decline" (click)="declineRequest(i,parentData,request)" nbButton size="small">
                                {{ 'Decline' }}
                            </button>
                        </div>
                        <div fxFlex="50" style="margin-left: 5px;">
                            <button class="approve" (click)="approveRequest(i,parentData,request)" nbButton size="small">
                                {{ 'Approve' }}
                            </button>
                        </div>

                    </div>

                    <div *ngIf="(request.isApproved || request.isDeclined)" class="action-btns" fxLayout="row"
                        fxLayoutAlign="space-between center" fxFlex="100">

                        <div *ngIf="request.isDeclined" fxFlex="100" style="margin-right: 5px;">
                            <button class="decline"  nbButton size="small" [disabled]="true">
                                {{ 'Declined' }}
                            </button>
                        </div>
                        <div *ngIf="request.isApproved" fxFlex="100" style="margin-left: 5px;">
                            <button class="approve" nbButton size="small" [disabled]="true">
                                {{ 'Approved' }}
                            </button>
                        </div>

                    </div>

                </div>

            </ng-container>
        </ng-container>

        <!-- Check if there are no tickets -->
        <div *ngIf="!parentData?.tickets || parentData?.tickets.length === 0" class="no-data-message">
            No Pending Requests found.
        </div>
    </ng-container>

    <ng-container *ngIf="parentData?.appName === 'Car Request'">
        <ng-container *ngIf="parentData?.tickets && parentData?.tickets.length > 0">
            <ng-container>

                <div class="request-container" *ngFor="let request of parentData?.tickets; let i=index" fxLayout="column">
                    <div class="request-details">
                        <div class="name">{{request?.travellerName}}’s Car Request is waiting for your approval</div>
                        <div class="name">Request ID : <span class="date">{{request?.requestID}}</span></div>
                        <div class="name">Requested Date : <span class="date">{{request.createdOn}}</span></div>
                        <div class="name">Mobile Number : <span class="date">{{request.mobileNumber}}</span></div>
                        <div class="name">Pick Up Date : <span class="date">{{request.pickupDate}} {{request.pickupTime}}</span></div>
                        <div class="name">Note For Vendor : <span class="date">{{request.note_For_Vendor}}</span></div>
                        <div class="name">Note For Coordinator : <span class="date">{{request.note_For_Coordinator}} </span></div>
                        <!-- <div fxLayout="row" fxLayoutAlign="start start" class="vendor">
                                        <div>No of days:&nbsp;</div>
                                        <div>{{request?.leaveQuantityInDays}}</div>
                                    </div>

                        <div class="date">
                            {{request?.date}}
                        </div> -->
                        <div style="width: 100%;" class="remark">
                            <div style="width:100%">
                                <textarea class="remark-textarea" [(ngModel)]="request.remark" nbInput
                                    placeholder="Please enter your remarks" (ngModelChange)="request.showRemarkError = false"></textarea>
                                    <div class="error" *ngIf="request.showRemarkError">Please enter your remarks</div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!request['isApproved'] && !request['isDeclined']" class="action-btns" fxLayout="row"
                        fxLayoutAlign="space-between center" fxFlex="100">

                        <div fxFlex="50" style="margin-right: 5px;">
                            <button class="decline" (click)="declineRequest(i,parentData,request)" nbButton size="small">
                                {{ 'Decline' }}
                            </button>
                        </div>
                        <div fxFlex="50" style="margin-left: 5px;">
                            <button class="approve" (click)="approveRequest(i,parentData,request)" nbButton size="small">
                                {{ 'Approve' }}
                            </button>
                        </div>

                    </div>

                    <div *ngIf="(request.isApproved || request.isDeclined)" class="action-btns" fxLayout="row"
                        fxLayoutAlign="space-between center" fxFlex="100">

                        <div *ngIf="request.isDeclined" fxFlex="100" style="margin-right: 5px;">
                            <button class="decline"  nbButton size="small" [disabled]="true">
                                {{ 'Declined' }}
                            </button>
                        </div>
                        <div *ngIf="request.isApproved" fxFlex="100" style="margin-left: 5px;">
                            <button class="approve" nbButton size="small" [disabled]="true">
                                {{ 'Approved' }}
                            </button>
                        </div>

                    </div>

                </div>

            </ng-container>
        </ng-container>

        <!-- Check if there are no tickets -->
        <div *ngIf="!parentData?.tickets || parentData?.tickets.length === 0" class="no-data-message">
            No Pending Requests found.
        </div>
    </ng-container>

       <ng-container *ngIf="parentData?.appName === 'Synergy Request'">
        <ng-container *ngIf="parentData?.tickets && parentData?.tickets.length > 0">
            <ng-container *ngFor="let item of parentData?.tickets; let i=index">

                <div fxLayout="column" class="request-container"  [ngClass]="{'first-card': i === 0}">
                    <div class="request-details">
                        <div class="name">{{item?.advancerequestraisedby}}’s Synergy request is waiting for your approval with following details</div>
                        <div>
                            <div class="date">
                          Type:  {{item?.advanceFlag? "Advance Request" :"Settlement Request"}}
                        </div>
                        <div class="date">
                          Date of request:  {{item?.dateofrequest}}
                        </div>
                        <div class="date">
                            Voucher No: {{item?.voucherId}}
                        </div>
                        <div class="date">
                            Amount :{{item?.requestedamount}}
                        </div>
                        </div>
                        <div style="width: 100%;" class="remark">
                            <div style="width:100%">
                                <textarea class="remark-textarea" [(ngModel)]="item.remark" nbInput
                                    placeholder="Please enter your remarks" (ngModelChange)="item.showRemarkError = false"></textarea>
                                    <div class="error" *ngIf="item.showRemarkError">Please enter your remarks</div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!(item.isApproved || item.isDeclined)" class="action-btns" fxLayout="row"
                        fxLayoutAlign="space-between center" fxFlex="100">

                        <div fxFlex="50" style="margin-right: 5px;">
                            <button class="decline" (click)="declineRequest(j,item,item)" nbButton size="small">
                                {{ 'Decline' }}
                            </button>
                        </div>
                        <div fxFlex="50" style="margin-left: 5px;">
                            <button class="approve" (click)="approveRequest(j,item,item)" nbButton size="small">
                                {{ 'Approve' }}
                            </button>
                        </div>

                    </div>
                    <div *ngIf="(item.isApproved || item.isDeclined)" class="action-btns" fxLayout="row"
                        fxLayoutAlign="space-between center" fxFlex="100">

                        <div *ngIf="item.isDeclined" fxFlex="100" style="margin-right: 5px;">
                            <button class="decline"  nbButton size="small" [disabled]="true">
                                {{ 'Declined' }}
                            </button>
                        </div>
                        <div *ngIf="item.isApproved" fxFlex="100" style="margin-left: 5px;">
                            <button class="approve" nbButton size="small" [disabled]="true">
                                {{ 'Approved' }}
                            </button>
                        </div>

                    </div>

                </div>

            </ng-container>
        </ng-container>

        <!-- Check if there are no tickets -->
        <div *ngIf="!parentData?.tickets || parentData?.tickets.length === 0" class="no-data-message">
            <div class="empty-data" fxFlex="100" fxLayout="column" fxLayoutAlign="center center">
                <div>
                    <img height="80" [src]="EmptyState" alt="Empty">
                </div>
                <span>No Pending Requests found.</span>
            </div>
        </div>
    </ng-container>
    
    </div>
</div>
